module.exports = __webpack_public_path__ + "static/media/averta-bold.74ce1c01.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta-bold.woff2
// module id = 845
// module chunks = 4